import { MetaPluginsList } from "./MetaPluginsList";

export default MetaPluginsList;
